import {
  ONBOARDING_BASE_URL,
  ONBOARDING_PLAN_PRESENTATION_URL,
  OVERVIEW_BASE_URL,
  PERSONAL_INFORMATION_URL,
  SETTINGS_BANK_ACCOUNT_URL,
} from 'utils/urls';

const COMPANY_ACCOUNT_TAG = 'company_account';
const BANK_ACCOUNT_TAG = 'bank_account';
const SUBSCRIPTION_PAID = 'subscription_paid';
const FIRST_STEPS_COMPLETED_TAG = 'first_steps_completed';

const handleNextStepBySellerTag = (sellerTags: string[]) => {
  const isCompletedCompanyAccount = sellerTags.includes(COMPANY_ACCOUNT_TAG);
  const isCompletedBankAccount = sellerTags.includes(BANK_ACCOUNT_TAG);
  const isCompletedFirstStep = sellerTags.includes(FIRST_STEPS_COMPLETED_TAG);

  if (isCompletedFirstStep) {
    return OVERVIEW_BASE_URL;
  }

  if (isCompletedBankAccount && isCompletedCompanyAccount) {
    return ONBOARDING_PLAN_PRESENTATION_URL;
  }

  if (isCompletedBankAccount && !isCompletedCompanyAccount) {
    return PERSONAL_INFORMATION_URL;
  }

  if (!isCompletedBankAccount && isCompletedCompanyAccount) {
    return SETTINGS_BANK_ACCOUNT_URL;
  }

  return ONBOARDING_BASE_URL;
};

export {
  handleNextStepBySellerTag,
  COMPANY_ACCOUNT_TAG,
  BANK_ACCOUNT_TAG,
  FIRST_STEPS_COMPLETED_TAG,
  SUBSCRIPTION_PAID,
};
